// Liste des étoiles disponibles
// signatureGroupId : IDs des groupes de distribution signature Exchange
//   sourceGroupId → groupe dont l'utilisateur est retiré quand il quitte cette étoile
//   destGroupId   → groupe auquel l'utilisateur est ajouté quand il rejoint cette étoile
export const AVAILABLE_STARS = [
    {
        value: 'AMWEB', label: 'AMWEB', trigramme: 'AMW', domaine: 'amws.space',
        signatureGroupId: { sourceGroupId: '9f09a306-9252-4164-8e70-c19c501c96ba', destGroupId: '9f09a306-9252-4164-8e70-c19c501c96ba' },
    },
    {
        value: 'Clariteam', label: 'Clariteam', trigramme: 'CLA', domaine: 'clariteam.com',
        signatureGroupId: { sourceGroupId: 'f827459e-b388-4f37-acbe-f58ac4683494', destGroupId: 'f827459e-b388-4f37-acbe-f58ac4683494' },
    },
    {
        value: 'Cassipoee', label: 'Cassipoee', trigramme: 'CNS', domaine: 'constellation.fr',
        signatureGroupId: { sourceGroupId: '048e79ec-e364-46c4-8de0-2f40e8395f33', destGroupId: '048e79ec-e364-46c4-8de0-2f40e8395f33' },
    },
    {
        value: 'Constellation', label: 'Constellation', trigramme: 'CNS', domaine: 'constellation.fr',
        signatureGroupId: { sourceGroupId: '048e79ec-e364-46c4-8de0-2f40e8395f33', destGroupId: '048e79ec-e364-46c4-8de0-2f40e8395f33' },
    },
    {
        value: 'Easyteam', label: 'Easyteam', trigramme: 'EAZ', domaine: 'easyteam.fr',
        signatureGroupId: { sourceGroupId: 'fd2ffc8f-3d4d-4a29-a49b-f588d4a4bb4c', destGroupId: 'fd2ffc8f-3d4d-4a29-a49b-f588d4a4bb4c' },
    },
    {
        value: 'Endexar', label: 'Endexar', trigramme: 'EDX', domaine: 'endexar.com',
        signatureGroupId: { sourceGroupId: '6a5c6875-3928-4b71-b964-69577f2c19a3', destGroupId: '6a5c6875-3928-4b71-b964-69577f2c19a3' },
    },
    {
        value: 'Ekyo', label: 'Ekyo', trigramme: 'EKY', domaine: 'ekyo.app',
        signatureGroupId: { sourceGroupId: '38b93127-facb-48ce-8a1e-b2311ab1a23f', destGroupId: '38b93127-facb-48ce-8a1e-b2311ab1a23f' },
    },
    {
        value: 'Kanopee', label: 'Kanopee', trigramme: 'KNP', domaine: 'kanopee.io',
        signatureGroupId: { sourceGroupId: '029b09e3-fe63-4353-b31b-a4a41ca078b3', destGroupId: '029b09e3-fe63-4353-b31b-a4a41ca078b3' },
    },
    {
        value: 'Kapela', label: 'Kapela', trigramme: 'KPL', domaine: 'kapela.fr',
        signatureGroupId: { sourceGroupId: '24919f95-9c54-45ee-8cd1-a1ea9e1833f6', destGroupId: '24919f95-9c54-45ee-8cd1-a1ea9e1833f6' },
    },
    {
        value: 'Login Sécurité', label: 'Login Sécurité', trigramme: 'LSE', domaine: 'login-securite.com',
        signatureGroupId: { sourceGroupId: 'f9698b13-73b5-45fa-a057-aed7d476e37e', destGroupId: 'f9698b13-73b5-45fa-a057-aed7d476e37e' },
    },
    {
        value: 'Novahé', label: 'Novahé', trigramme: 'NOV', domaine: 'novahe.fr',
        signatureGroupId: { sourceGroupId: '3074c383-8992-43b8-9f37-00b8b51f4f8a', destGroupId: '3074c383-8992-43b8-9f37-00b8b51f4f8a' },
    },
    {
        value: 'StelR', label: 'StelR', trigramme: 'STL', domaine: 'stelr.fr',
        signatureGroupId: { sourceGroupId: '69421eab-79e4-43d2-9658-10e9892f4ea8', destGroupId: '69421eab-79e4-43d2-9658-10e9892f4ea8' },
    },
    {
        value: 'Tionis', label: 'Tionis', trigramme: 'TIO', domaine: 'tionis.fr',
        signatureGroupId: { sourceGroupId: '00bb6189-df01-43e4-b5d4-91724cc2dc75', destGroupId: '00bb6189-df01-43e4-b5d4-91724cc2dc75' },
    },
    {
        value: 'Tyr Networks', label: 'Tyr Networks', trigramme: 'TYR', domaine: 'trynetworks.io',
        signatureGroupId: { sourceGroupId: 'ce13835f-a26a-4050-b075-6e2bce696169', destGroupId: 'ce13835f-a26a-4050-b075-6e2bce696169' },
    },
];
